// Note: This is a full React + Material UI functional component conversion
// You’ll need to break this into smaller components (e.g., AddressTable, Filters, ActionButtons) for better scalability

import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Tooltip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Row,
  CircularProgress,
  ListSubheader,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import axios from "axios";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Link, useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";

const AddressManagement = () => {
  const navigate = useNavigate();
  const [selectAll, setSelectAll] = useState(false);
  const [selectedAds, setSelectedAds] = useState([]);

  const [asset, setAsset] = useState("");
  const [adType, setAdType] = useState("");
  const [searchStr, setSearchStr] = useState("");
  const [stpLoader, setStpLoader] = useState(false);
  const [counterCurrency, setCounterCurrency] = useState([]);
  const [currencyDetailsList, setCurrencyDetailsList] = useState([]);
  const [whitelistAddressDetailsList, setWhitelistAddressDetailsList] =
    useState([]);
  const [isWhitelistEnabled, setIsWhitelistEnabled] = useState(1);
  const BROKERID = localStorage.getItem("BROKERID");
  const [idsToUpdate, setIdsToUpdate] = useState("");
  const [whiteListEnableDisableFlag, setWhiteListEnableDisableFlag] =
    useState(null);
  const [addressUpdatePasskey, setAddressUpdatePasskey] = useState(null);
  const [isSecurityModalOpen, setIsSecurityModalOpen] = useState(false);

  const [addAddressLabel, setAddAddressLabel] = useState("");
  const [addCoin, setAddCoin] = useState("");
  const [addAddress, setAddAddress] = useState("");
  const [network, setNetwork] = useState("");
  const [addToWhitelist, setAddToWhitelist] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [errorData, setErrorData] = useState(null);

  const [securityModalOpen, setSecurityModalOpen] = useState(false);
  const [addressPasskey, setAddressPasskey] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [addAddressModal, setAddAddressModal] = useState(false);

  const [currencyId, setCurrencyId] = useState(null);

  const [tokenList, setTokenList] = useState([]);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [addressDeletePasskey, setAddressDeletePasskey] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [addressDeleteMultiplePasskey, setAddressDeleteMultiplePasskey] =
    useState("");
  const [deleteMultipleDialogOpen, setDeleteMultipleDialogOpen] =
    useState(false);

  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [addressEditPasskey, setAddressEditPasskey] = useState(false);
  const [updateAddressFlag, setUpdateAddressFlag] = useState("");
  const [open, setOpen] = useState(false);
  const [memoTag, setMemoTag] = useState("");
  const [search, setSearch] = useState("");
  const handleSearchChange = (e) => {
    setSearchStr(e.target.value);
  };

  useEffect(() => {
    getAllAddressList();
  }, [asset, adType, searchStr]);
  useEffect(() => {
    if (addressDeletePasskey?.length === 6) {
      deleteAddress();
    }
  }, [addressDeletePasskey]);
  useEffect(() => {
    if (addressUpdatePasskey?.length === 6) {
      updateMultipleAddress();
    }
  }, [addressUpdatePasskey]);
  useEffect(() => {
    if (addressEditPasskey?.length === 6) {
      updateAddress();
    }
  }, [addressEditPasskey]);

  useEffect(() => {
    if (addAddress !== "") {
      checkNodeAddress(addAddress, currencyId);
    }
  }, [addAddress]);
  useEffect(() => {
    if (addressPasskey?.length === 6) {
      submitAddress();
    }
  }, [addressPasskey]);
  useEffect(() => {
    if (addressDeleteMultiplePasskey?.length === 6) {
      handleDelete();
    }
  }, [addressDeleteMultiplePasskey]);
  useEffect(() => {
    if (addAddress !== "") {
      checkNodeAddress(addAddress, currencyId);
    }
  }, [addAddress]);

  // Dummy data for demonstration
  useEffect(() => {
    getBasecurrencyList();
    getCurrencyPrecision();
    getEnableDisableStatus();
  }, []);

  const getAllAddressList = async () => {
    try {
      setStpLoader(true);

      const payload = {
        uuid: localStorage.getItem("uuid"),
        crypto: searchStr ? "" : asset === "" ? "All" : asset,
        isWhitelist: adType === "" ? "" : adType,
        searchStr: searchStr,
        offset: 1,
        limit: 100,
      };

      const response = await axios.post(
        `${WEBSERVICE}transaction/getWhitelistedAddress`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      setStpLoader(false);

      if (response.data.error?.error_data === 0) {
        const list = response.data.whitelistedAddressList || [];
        const transformedList = list.map((item) => ({
          id: item.id,
          uuid: item.uuid,
          userId: item.userId,
          securityCode: item.securityCode,
          otp: item.otp,
          addressLabel: item.addressLabel,
          currencyId: item.currencyId,
          crypto: item.crypto,
          address: item.address,
          network: item.network,
          memo: item.memo,
          isWhitelist: item.isWhitelist,
          searchStr: item.searchStr,
          offset: item.offset,
          limit: item.limit,
          getTotalROws: item.getTotalROws,
          createdOn: item.createdOn,
        }));
        setWhitelistAddressDetailsList(transformedList);
      } else {
        showToast("error", response.data.error.error_msg);
      }
    } catch (err) {
      setStpLoader(false);
      showToast("error", "Something went wrong");
    }
  };

  const getBasecurrencyList = async () => {
    try {
      const response = await axios.get(
        `${WEBSERVICE}home/getAllCurrency/${BROKERID}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );
      setCounterCurrency(response.data.currencyList || []);
    } catch (err) {
      showToast("error", "Failed to load currencies");
    }
  };
  const getCurrencyPrecision = async () => {
    try {
      const response = await axios.get(`${WEBSERVICE}home/currencyPrecision`);
      setCurrencyDetailsList(response.data.precisionList || []);
    } catch (err) {
      showToast("error", "Failed to load currency precision");
    }
  };

  const getEnableDisableStatus = async () => {
    try {
      const payload = { uuid: localStorage.getItem("uuid") };
      const response = await axios.post(
        `${WEBSERVICE}transaction/getEnableDisableStatus`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data.error.error_data == 0) {
        setIsWhitelistEnabled(response.data.addressWhitelistStatus);
      } else {
        setIsWhitelistEnabled(0);
        // showToast("error", response.data.error.error_msg);
      }
    } catch (err) {
      setIsWhitelistEnabled(0);
      showToast("error", "Error checking whitelist status");
    }
  };

  const handleCheckboxChange = (ads) => {
    const exists = selectedAds.find((item) => item.id === ads.id);
    let updatedSelection;
    if (exists) {
      updatedSelection = selectedAds.filter((item) => item.id !== ads.id);
    } else {
      updatedSelection = [...selectedAds, ads];
    }
    setSelectedAds(updatedSelection);
    setSelectAll(
      updatedSelection.length === whitelistAddressDetailsList.length
    );
  };

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);
    if (checked) {
      setSelectedAds([...whitelistAddressDetailsList]);
    } else {
      setSelectedAds([]);
    }
  };

  // const handleCheckboxChange = (row) => {
  //   setSelectedAds((prevSelected) => {
  //     const alreadySelected = prevSelected.find((item) => item.id === row.id);
  //     if (alreadySelected) {
  //       // Remove it
  //       return prevSelected.filter((item) => item.id !== row.id);
  //     } else {
  //       // Add it
  //       return [...prevSelected, row];
  //     }
  //   });
  // };

  const openUpdateMultipleAddressSecurityModal = (flag) => {
    const twoFactor = Number(localStorage.getItem("twoFactorAuth"));

    if (twoFactor === 0) {
      showToast("error", "Please turn on your two-factor authentication");
      return;
    }

    let selectedIds = [];

    console.log("selectedAds", selectedAds);

    if (flag === 1) {
      // Remove from whitelist: current whitelist status should be 2
      selectedIds = selectedAds
        .filter((item) => item.isWhitelist === 2)
        .map((item) => item.id);

      if (selectedIds.length === 0) {
        showToast(
          "error",
          "Selected addresses are already removed from whitelist"
        );
        return;
      }
    } else if (flag === 2) {
      // Add to whitelist: current whitelist status should be 1
      selectedIds = selectedAds
        .filter((item) => item.isWhitelist === 1)
        .map((item) => item.id);

      if (selectedIds.length === 0) {
        showToast("error", "Selected addresses are already added to whitelist");
        return;
      }
    }

    // If valid, open modal and set state
    setIdsToUpdate(selectedIds.join(","));
    setWhiteListEnableDisableFlag(flag);
    setAddressUpdatePasskey(null);
    setIsSecurityModalOpen(true);
  };

  const handleCloseAddAddressModal = () => {
    setAddAddressModal(false);
    resetAddressData();
  };

  const resetAddressData = () => {
    setAddAddressLabel("");
    setAddCoin("");
    setAddAddress("");
    setNetwork("");
    setMemoTag("");
    setErrorMsg("");
  };

  const updateMultipleAddress = () => {
    if (!addressUpdatePasskey) {
      showToast("error", "Security code cannot be empty !!");
      return;
    }

    setStpLoader(true);

    const firstId = idsToUpdate.split(",")[0];
    const selectedIndex = selectedAds.findIndex((item) => item.id === firstId);

    if (selectedIndex === -1) {
      showToast("error", "Invalid selection");
      setStpLoader(false);
      return;
    }

    const selectedItem = selectedAds[selectedIndex];

    const jsonObj = {
      uuid: localStorage.getItem("uuid"),
      securityCode: addressUpdatePasskey,
      id: idsToUpdate,
      addressLabel: selectedItem.addressLabel,
      currencyId: selectedItem.currencyId,
      crypto: selectedItem.crypto,
      address: selectedItem.address,
      network: selectedItem.network,
      memo: selectedItem.memo,
      isWhitelist: whiteListEnableDisableFlag,
    };

    axios
      .post(`${WEBSERVICE}transaction/addressWhitelist`, jsonObj, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((res) => {
        const response = res.data;
        setStpLoader(false);

        if (response.error?.error_data === 0) {
          setSelectedAds([]);
          if (whiteListEnableDisableFlag === 2) {
            showToast("success", "Selected Addresses whitelisted successfully");
          } else {
            showToast(
              "success",
              "Selected Addresses removed from whitelist successfully"
            );
          }

          setTimeout(() => {
            setIsSecurityModalOpen(false);
            setAddressUpdatePasskey("");
            setWhiteListEnableDisableFlag(null);
            getAllAddressList(); // Your refetch function
          }, 1000);
        } else {
          showToast("error", response.error.error_msg);
        }
      })
      .catch((err) => {
        setStpLoader(false);
        showToast("error", "Something went wrong");
      });
  };

  const onAssetChange = async (coin) => {
    const newCurrencyId = getCurrencyId(coin);
    console.log("newCurrencyId", newCurrencyId);

    setAddCoin(coin);
    setCurrencyId(newCurrencyId);

    // if (addAddress !== "") {
    //   await checkNodeAddress(addAddress, newCurrencyId);
    // }

    await currencyTokenTypeById(newCurrencyId);
  };

  const getCurrencyId = (coin) => {
    console.log("currencyDetailsList", currencyDetailsList);
    console.log("coin", coin);

    const currencyInfo = currencyDetailsList.find(
      (info) => info.CURRENCY === coin
    );

    console.log("currencyInfo", currencyInfo);

    return currencyInfo ? currencyInfo.CURRENCYID : null;
  };

  const checkNodeAddress = async (address, cid = currencyId) => {
    if (!addCoin) {
      showToast("error", "Please select coin before adding address"); // Replace with toast
      setAddAddress("");
      return;
    }

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/checkNodeAddress`,
        JSON.stringify({
          toAdd: address,
          currencyId: cid,
          tokenType: network.toLowerCase(),
        }),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const result = response.data;
      setErrorData(result.error.error_data);
      setErrorMsg(result.error.error_msg);

      if (result.error.error_data !== 0) {
        setAddAddress("");
      } else {
        setErrorMsg("Valid address");
      }
    } catch (err) {
      console.error("Error in checkNodeAddress:", err);
      setErrorMsg("Failed to validate address");
      setAddAddress("");
    }
  };

  const MemoTagCoin = ["A", "XRP", "XLM", "PUSD", "HBAR", "BLUC", "HCX"];

  const currencyTokenTypeById = async (currencyId) => {
    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/currencyTokenTypeById`,
        JSON.stringify({ currencyId }),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const result = response.data;

      if (result.error.error_data === 0) {
        if (!result.response || result.response.length === 0) {
          setTokenList([]);
        } else {
          setTokenList(result.response);
          setNetwork(result.response[0].tokenType);
        }
      } else {
        showToast("error", result.error.error_msg); // Replace with your toast logic
      }
    } catch (error) {
      console.error("Error fetching token types:", error);
      showToast("error", "Something went wrong while fetching token types.");
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setSecurityModalOpen(true);
  };

  const submitAddress = async () => {
    if (!addressPasskey) {
      showToast("error", "Security code cannot be empty !!");
      return;
    }

    setStpLoader(true);

    const payload = {
      uuid: localStorage.getItem("uuid"),
      securityCode: addressPasskey,
      id: "",
      addressLabel: addAddressLabel,
      currencyId: currencyId,
      crypto: addCoin,
      address: addAddress,
      network: network === "NATIVE" ? addCoin : network,
      memo: memoTag,
      isWhitelist: addToWhitelist ? 2 : 1,
    };

    try {
      const { data: response } = await axios.post(
        `${WEBSERVICE}transaction/addressWhitelist`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      setStpLoader(false);
      if (response.error.error_data === 0) {
        showToast("success", "Address added successfully");
        handleCloseAddAddressModal();
        setSecurityModalOpen(false);
        getAllAddressList();
      } else {
        showToast("error", response.error.error_msg);
      }
    } catch (err) {
      console.error(err);
      setStpLoader(false);
      showToast("error", "An unexpected error occurred");
    }
  };

  const addAddressWhitelist = () => {
    setAddressPasskey(null);
    setSecurityModalOpen(true);
  };

  /** Delete Selected */
  const openMultipleDeleteAddressSecurityModal = () => {
    var twoFactor = Number(localStorage.getItem("twoFactorAuth"));
    if (twoFactor === 0) {
      showToast(
        "error",
        "Please turn on your two factor authentication",
        "danger"
      );
    } else {
      setDeleteMultipleDialogOpen(true);
    }
  };

  const openDeleteAddressSecurityModal = (id) => {
    const twoFactor = Number(localStorage.getItem("twoFactorAuth"));
    if (twoFactor === 0) {
      showToast("error", "Please turn on your two factor authentication");
    } else {
      setSelectedAddressId(Number(id));
      setAddressDeletePasskey(null);
      setDeleteDialogOpen(true);
    }
  };

  const openEditAddressSecurityModal = (id, val) => {
    const twoFactor = Number(localStorage.getItem("twoFactorAuth"));
    if (twoFactor === 0) {
      showToast("error", "Please turn on your two factor authentication");
    } else {
      setSelectedAddressId(Number(id));
      setUpdateAddressFlag(Number(val));

      setEditDialogOpen(true);
    }
  };

  const updateAddress = async () => {
    if (!addressEditPasskey) {
      showToast("error", "Security code cannot be empty !!");
      return;
    }

    setLoading(true); // Set loading state if applicable

    const selected = whitelistAddressDetailsList[selectedAddressId];

    const jsonObj = {
      uuid: localStorage.getItem("uuid"),
      securityCode: addressEditPasskey,
      id: selected.id,
      addressLabel: selected.addressLabel,
      currencyId: selected.currencyId,
      crypto: selected.crypto,
      address: selected.address,
      network: selected.network,
      memo: selected.memo,
      isWhitelist: updateAddressFlag,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/addressWhitelist`,
        JSON.stringify(jsonObj),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const result = response.data;
      setLoading(false);

      if (result.error?.error_data === 0) {
        showToast(
          "success",
          updateAddressFlag === 2
            ? "Address whitelisted successfully"
            : "Address removed from whitelist successfully"
        );

        setTimeout(() => {
          setEditDialogOpen(false);
          getAllAddressList();
        }, 1000);
      } else {
        showToast("error", result.error?.error_msg || "An error occurred");
      }
    } catch (error) {
      console.error("Update failed:", error);
      setLoading(false);
      showToast("error", "Failed to update address");
    }
  };

  const handleDelete = async () => {
    if (!addressDeleteMultiplePasskey) {
      showToast("error", "Security code cannot be empty !!");
      return;
    }

    setLoading(true);

    const selectedIds = selectedAds.map((item) => item.id).join(",");

    const payload = {
      uuid: localStorage.getItem("uuid"),
      securityCode: addressDeleteMultiplePasskey,
      id: selectedIds,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/deleteWhitelistedAddress`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      setLoading(false);

      if (response.data.error.error_data === 0) {
        showToast("success", "Selected Addresses deleted successfully");

        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        showToast("error", response.data.error.error_msg);
      }
    } catch (err) {
      setLoading(false);
      showToast("error", "Something went wrong");
    }
  };

  const deleteAddress = async () => {
    if (!addressDeletePasskey) {
      showToast("error", "Security code cannot be empty !!", "danger");
      return;
    }

    setLoading(true);

    const payload = {
      uuid: localStorage.getItem("uuid"),
      securityCode: addressDeletePasskey,
      id: whitelistAddressDetailsList[selectedAddressId]?.id,
      crypto: whitelistAddressDetailsList[selectedAddressId]?.crypto,
      currencyId: whitelistAddressDetailsList[selectedAddressId]?.currencyId,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/deleteWhitelistedAddress`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      setLoading(false);

      if (response.data.error.error_data === 0) {
        showToast("success", "Address deleted successfully");
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        showToast("error", response.data.error.error_msg);
      }
    } catch (err) {
      setLoading(false);
      showToast("error", "An error occurred while deleting address");
    }
  };

  const downloadWhitelistedAddress = () => {
    const uuid = localStorage.getItem("uuid");
    const timestamp = new Date().getTime();
    const accessToken = localStorage.getItem("access_token");

    fetch(
      `${process.env.REACT_APP_WEBSERVICE}/transaction/getWhitelistedAddress/${uuid}`,
      {
        method: "GET",
        headers: {
          Authorization: `BEARER ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    )
      .then((resp) => resp.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = `download_${timestamp}.xlsx`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => {
        // Replace this with your alert system (Snackbar, toast, etc.)
        showToast("error", "Failed to export");
      });
  };

  const handleChange = (event) => {
    setAsset(event.target.value);
    setOpen(false);
    setSearch("");
  };

  const filteredCoins = counterCurrency.filter((coin) =>
    coin.toLowerCase().includes(search.toLowerCase())
  );

  const handleKeyDown = (event) => {
    const keysToBlock = [
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z",
    ];
    if (keysToBlock.includes(event.key.toLowerCase())) {
      event.preventDefault();
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        pt: 3,
        pl: 2,
      }}
    >
      <Container maxWidth="xl">
        <Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" mb={2}>
              Address Management
            </Typography>
            <ContainedButton
              variant="contained"
              startIcon={
                <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
              }
              onClick={() => navigate("/settings")}
            >
              Back
            </ContainedButton>
          </Box>

          <Box display="flex" alignItems="center" gap={2} mb={2}>
            <Box display="flex" alignItems="center" gap={2} mb={2}>
              {isWhitelistEnabled == 0 ? (
                <Typography color="error">
                  {" "}
                  <NotInterestedIcon /> WhiteList Disabled
                </Typography>
              ) : (
                <Typography color="success">
                  {" "}
                  <CheckCircleOutlineIcon /> WhiteList Enabled
                </Typography>
              )}
              <Link
                to="/settings"
                className="no-underline"
                style={{ border: "none" }}
              >
                <Typography color="primary" sx={{ cursor: "pointer" }}>
                  WhiteList Settings
                </Typography>
              </Link>
            </Box>
          </Box>
        </Box>

        <Grid container spacing={2} mb={2}>
          <Grid size={{ xs: 6, md: 3 }}>
            <FormControl fullWidth size="small">
              <InputLabel>Coin</InputLabel>
              <Select
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                value={asset}
                label="Coin"
                onChange={handleChange}
                renderValue={(selected) => selected || "All Coins"}
                MenuProps={{
                  disableAutoFocusItem: true,
                  PaperProps: {
                    onKeyDown: handleKeyDown, // Block key-based selection
                    style: {
                      maxHeight: 300,
                      overflowY: "auto",
                    },
                  },
                }}
              >
                <ListSubheader disableSticky>
                  <TextField
                    autoFocus
                    placeholder="Search coins"
                    fullWidth
                    size="small"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    onClick={(e) => e.stopPropagation()} // prevent select from closing
                    onKeyDown={(e) => e.stopPropagation()} // block native behavior in input
                  />
                </ListSubheader>

                <MenuItem value="">All Coins</MenuItem>

                {filteredCoins.length > 0 ? (
                  filteredCoins.map((cur, index) => (
                    <MenuItem key={index} value={cur}>
                      {cur}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No coins found</MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 6, md: 3 }}>
            <FormControl fullWidth size="small">
              <InputLabel>Type</InputLabel>
              <Select
                value={adType}
                onChange={(e) => setAdType(e.target.value)}
                label="Type"
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value={2}>Whitelisted</MenuItem>
                <MenuItem value={1}>Not Whitelisted</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 6, md: 3 }}>
            <TextField
              fullWidth
              size="small"
              label="Search"
              value={searchStr}
              onChange={handleSearchChange}
              placeholder="Address label, coin, network..."
            />
          </Grid>

          <Grid size={{ xs: 6, md: 3 }}>
            <Box>
              <IconButton>
                <DownloadIcon
                  onClick={downloadWhitelistedAddress}
                ></DownloadIcon>
              </IconButton>
              <IconButton>
                <AddIcon onClick={() => setAddAddressModal(true)} />
              </IconButton>
            </Box>
          </Grid>
        </Grid>

        <Box
          display="flex"
          justifyContent="space-between"
          flexDirection={{ xs: "column", md: "row" }}
          mb={2}
        >
          <Box>
            <FormControlLabel
              control={
                <Checkbox checked={selectAll} onChange={handleSelectAll} />
              }
              label={`${selectedAds.length} Address Selected`}
            />
          </Box>

          <Box display="flex" gap={1}>
            <OutlinedButton
              onClick={() => openUpdateMultipleAddressSecurityModal(2)}
              label={"Add to Whitelist"}
              disabled={selectedAds.length === 0}
            />
            <OutlinedButton
              onClick={() => openUpdateMultipleAddressSecurityModal(1)}
              label={"Remove from Whitelist"}
              disabled={selectedAds.length === 0}
            />
            <OutlinedButton
              onClick={() => openMultipleDeleteAddressSecurityModal()}
              label={"Delete"}
              disabled={selectedAds.length === 0}
            />
          </Box>
        </Box>

        {whitelistAddressDetailsList.length === 0 ? (
          <Paper sx={{ p: 3, textAlign: "center" }}>
            <Typography>No Address Found!</Typography>
          </Paper>
        ) : (
          <Paper
            sx={{
              overflow: "auto",
              maxHeight: "70vh",
              "&::-webkit-scrollbar": {
                width: "2px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "transparent",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#b0b0b0",
                borderRadius: "2px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#888",
              },
            }}
          >
            {" "}
            {/* Scrollable container */}
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>Address Label</TableCell>
                  <TableCell>Whitelist</TableCell>
                  <TableCell>Coin</TableCell>
                  <TableCell>Address</TableCell>
                  <TableCell>Network</TableCell>
                  <TableCell>Memo</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {whitelistAddressDetailsList.map((ads, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <Checkbox
                        key={ads.id}
                        checked={selectedAds.some((item) => item.id === ads.id)}
                        onChange={() => handleCheckboxChange(ads)}
                      />
                    </TableCell>
                    <TableCell>{ads.addressLabel}</TableCell>
                    <TableCell>
                      {ads.isWhitelist === 2 ? (
                        <Typography color="success">WhiteListed</Typography>
                      ) : (
                        <Typography color="error">Not WhiteListed</Typography>
                      )}
                    </TableCell>
                    <TableCell>{ads.crypto}</TableCell>
                    <TableCell>{ads.address}</TableCell>
                    <TableCell>{ads.network}</TableCell>
                    <TableCell>{ads.memo}</TableCell>
                    <TableCell>
                      <Box display="flex" justifyContent="space-between">
                        <Tooltip
                          title={
                            ads.isWhitelist === 2
                              ? "Remove from Whitelist"
                              : "Make it Whitelist"
                          }
                        >
                          <IconButton
                          // onClick={() => alert("Toggle whitelist")}
                          >
                            {ads.isWhitelist === 2 ? (
                              <ToggleOnIcon
                                onClick={() =>
                                  openEditAddressSecurityModal(index, 1)
                                }
                                sx={{ color: "green" }}
                              />
                            ) : (
                              <ToggleOffIcon
                                onClick={() =>
                                  openEditAddressSecurityModal(index, 2)
                                }
                              />
                            )}
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete Address">
                          <IconButton
                            onClick={() =>
                              openDeleteAddressSecurityModal(index)
                            }
                            sx={{ color: "red" }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        )}
      </Container>

      <Dialog
        open={isSecurityModalOpen}
        onClose={() => setIsSecurityModalOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" sx={{ visibility: "hidden" }}>
            S
          </Typography>
          <Typography variant="h6">Security Verification</Typography>
          <IconButton onClick={() => setIsSecurityModalOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2, mt: 2 }}>
            To secure your account, please complete the following verification
          </Typography>
          <TextField
            fullWidth
            label="Google verification code"
            type="number"
            value={addressUpdatePasskey || ""}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "").slice(0, 6);

              setAddressUpdatePasskey(value);
            }}
            inputProps={{ maxLength: 6 }}
            variant="outlined"
            autoComplete="new-password"
            sx={{ mb: 1, mt: 1 }}
            helperText="Enter the 6 digit code from Google Authenticator"
          />
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            pb: 2,
          }}
        >
          <ContainedButton
            variant="contained"
            color="primary"
            onClick={() => updateMultipleAddress()}
            disabled={stpLoader}
          >
            Submit
          </ContainedButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={addAddressModal}
        onClose={() => handleCloseAddAddressModal()}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" sx={{ visibility: "hidden" }}>
            A
          </Typography>
          <Typography variant="h6">Add Address</Typography>

          <IconButton onClick={() => handleCloseAddAddressModal()}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} mt={1}>
            <Grid size={12}>
              <TextField
                label="Address Label"
                fullWidth
                value={addAddressLabel}
                onChange={(e) => setAddAddressLabel(e.target.value)}
                inputProps={{ minLength: 4, maxLength: 20 }}
                required
              />
            </Grid>
            <Grid size={12}>
              <FormControl fullWidth required>
                <InputLabel>Coin</InputLabel>
                <Select
                  value={addCoin}
                  label="Coin"
                  onChange={(e) => {
                    setAddCoin(e.target.value);
                    onAssetChange(e.target.value);
                  }}
                >
                  {counterCurrency.map((coin) => (
                    <MenuItem key={coin} value={coin}>
                      {coin}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid size={12}>
              <FormControl fullWidth required>
                <InputLabel>Network</InputLabel>
                <Select
                  value={network}
                  label="Network"
                  onChange={(e) => setNetwork(e.target.value)}
                >
                  {tokenList.map((token, index) => (
                    <MenuItem key={index} value={token.tokenType}>
                      {token.tokenType}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid size={12}>
              <TextField
                label="Address"
                fullWidth
                value={addAddress}
                onChange={(e) => setAddAddress(e.target.value)}
                required
              />
              {errorData !== 0 && (
                <Typography color="error">{errorMsg}</Typography>
              )}
              {errorData == 0 && (
                <Typography color="success">{errorMsg}</Typography>
              )}
            </Grid>

            {MemoTagCoin?.includes(addCoin) ? (
              (
                addCoin === "HCX" ? (network !== "NATIVE" ? false : true) : true
              ) ? (
                <Grid size={12}>
                  <TextField
                    label={`${addCoin} Tag`}
                    fullWidth
                    value={memoTag}
                    onChange={(e) => setMemoTag(e.target.value)}
                    required
                  />
                </Grid>
              ) : null
            ) : null}

            <Grid size={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={addToWhitelist}
                    onChange={(e) => setAddToWhitelist(e.target.checked)}
                  />
                }
                label="Add address to whitelist"
              />
            </Grid>
          </Grid>
          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ContainedButton onClick={() => handleCloseAddAddressModal()}>
              Cancel
            </ContainedButton>
            <ContainedButton
              onClick={() => addAddressWhitelist()}
              type="submit"
              variant="contained"
              disabled={
                !addAddressLabel ||
                !addCoin ||
                !addAddress ||
                !network ||
                (MemoTagCoin?.includes(addCoin) &&
                  (addCoin === "HCX" ? network === "NATIVE" : true) &&
                  !memoTag)
              }
            >
              Submit
            </ContainedButton>
          </DialogActions>
        </DialogContent>
      </Dialog>

      {/* <Dialog
        open={securityModalOpen}
        onClose={() => setSecurityModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" sx={{ visibility: "hidden" }}>
            S
          </Typography>
          <Typography variant="h6">Security Verification</Typography>
          <IconButton onClick={() => setSecurityModalOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2, mt: 2 }}>
            To secure your account, please complete the following verification
          </Typography>

          <TextField
            label="Google verification code"
            type="number"
            fullWidth
            value={addressPasskey}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "").slice(0, 6);

              setAddressPasskey(value);
            }}
            onWheel={(e) => e.target.blur()}
            inputProps={{ maxLength: 6 }}
            margin="normal"
            helperText="Enter the 6-digit code from Google Authenticator"
          />
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            onClick={handleFinalSubmit}
            variant="contained"
            disabled={isSubmitting || addressPasskey?.length < 6}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog> */}

      <Dialog
        open={securityModalOpen}
        onClose={() => setSecurityModalOpen(false)}
        maxWidth="sm"
        fullWidth
        disableEscapeKeyDown
        // PaperProps={{
        //   sx: { borderRadius: 3, p: 3 },
        // }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" sx={{ visibility: "hidden" }}>
            S
          </Typography>
          <Typography variant="h6">Security Verification</Typography>
          <IconButton onClick={() => setSecurityModalOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2, mt: 2 }}>
            To secure your account, please complete the following verification
          </Typography>

          <TextField
            fullWidth
            type="number"
            label="Google verification code"
            value={addressPasskey || ""}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "").slice(0, 6);

              setAddressPasskey(value);
            }}
            placeholder="Enter the 6 digit code from Google Authenticator"
            inputProps={{ maxLength: 6 }}
            autoComplete="off"
            sx={{ mt: 1 }}
          />
          <Typography variant="caption" sx={{ mt: 1, display: "block" }}>
            Enter the 6 digit code from Google Authenticator
          </Typography>
        </DialogContent>

        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ContainedButton
            onClick={() => submitAddress()}
            variant="contained"
            color="primary"
            disabled={addressPasskey?.length < 6}
          >
            Submit
          </ContainedButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        disableEscapeKeyDown
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" sx={{ visibility: "hidden" }}>
            S
          </Typography>
          <Typography variant="h6">Security Verification</Typography>
          <IconButton onClick={() => setDeleteDialogOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2, mt: 2 }}>
            To secure your account, please complete the following verification
          </Typography>
          <TextField
            fullWidth
            label="Google verification code"
            type="number"
            value={addressDeletePasskey}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "").slice(0, 6);

              setAddressDeletePasskey(value);
            }}
            autoComplete="off"
            InputLabelProps={{ shrink: true }}
            inputProps={{ maxLength: 6 }}
            variant="outlined"
            margin="normal"
            helperText="Enter the 6-digit code from Google Authenticator"
          />
        </DialogContent>

        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mb: 2,
          }}
        >
          <ContainedButton
            variant="contained"
            color="primary"
            onClick={deleteAddress}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Submit"
            )}
          </ContainedButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={editDialogOpen}
        onClose={() => setEditDialogOpen(false)}
        disableEscapeKeyDown
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" sx={{ visibility: "hidden" }}>
            S
          </Typography>
          <Typography variant="h6">Security Verification</Typography>
          <IconButton onClick={() => setEditDialogOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2, mt: 2 }}>
            To secure your account, please complete the following verification
          </Typography>
          <TextField
            fullWidth
            label="Google verification code"
            type="number"
            value={addressEditPasskey}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "").slice(0, 6);

              setAddressEditPasskey(value);
            }}
            autoComplete="off"
            InputLabelProps={{ shrink: true }}
            inputProps={{ maxLength: 6 }}
            variant="outlined"
            margin="normal"
            helperText="Enter the 6-digit code from Google Authenticator"
          />
        </DialogContent>

        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ContainedButton
            variant="contained"
            color="primary"
            onClick={updateAddress}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Submit"
            )}
          </ContainedButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={deleteMultipleDialogOpen}
        onClose={() => setDeleteMultipleDialogOpen(false)}
        disableEscapeKeyDown
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" sx={{ visibility: "hidden" }}>
            S
          </Typography>
          <Typography variant="h6">Security Verification</Typography>
          <IconButton onClick={() => setDeleteMultipleDialogOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2, mt: 2 }}>
            To secure your account, please complete the following verification
          </Typography>

          <TextField
            fullWidth
            label="Google verification code"
            type="number"
            value={addressDeleteMultiplePasskey}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "").slice(0, 6);

              setAddressDeleteMultiplePasskey(value);
            }}
            autoComplete="off"
            InputLabelProps={{ shrink: true }}
            variant="outlined"
            margin="normal"
            helperText="Enter the 6-digit code from Google Authenticator"
          />
        </DialogContent>

        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mb: 2,
          }}
        >
          <ContainedButton
            variant="contained"
            color="primary"
            onClick={handleDelete}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Submit"
            )}
          </ContainedButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AddressManagement;
